import { render, staticRenderFns } from "./FirstTimePassword.vue?vue&type=template&id=fa0442fc&"
import script from "./FirstTimePassword.vue?vue&type=script&lang=js&"
export * from "./FirstTimePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports